import { combineReducers } from 'redux';
import harness from 'adc-harness-state';

import auth from './auth';
import account from './account';
import bill from './bill';
import cms from './cms';
import cpc from './cpc';
import contextHub from './contextHub';
import contracts from './contracts';
import instruments from './instruments';
import internetTier from './internetTier';
import payment from './payment';
import mobilePayment from './mobilePayment';
import latefeecredit from './latefeecredit';
import billData from './billData';
import autopay from './autopay';
import scheduledPayments from './scheduledPayments';
import applePay from './applePay';
import userMessages from './userMessages';
import moveBillDueDate from './moveBillDueDate';
import paymentPlan from './paymentPlan';
import collections from './collections';
import ltip from './ltip';
import installmentPlans from './installmentPlans';
import session from './session';
import user from './user';
import nowWalletInstruments from './nowWalletInstruments';
import nowPayment from './nowPayment';
import stepUp from './stepUp';
import statement from './futureStatement';
import otLines from './otLines';
import otPaymentTransactions from './otPaymentTransactions';
import otHOPInitialization from './otHOPInitialization';
import mobileDevicePayment from './mobileDevicePayment';
import currentXMAutopayInstrument from './currentXMAutopayInstrument';
import accountName from './accountName';
import xmEstimated from './xmEstimated';
import arrangement from './arrangement';

const rootReducer = combineReducers({
  auth,
  account,
  arrangement,
  bill,
  cms,
  cpc,
  contextHub,
  contracts,
  collections,
  instruments,
  internetTier,
  payment,
  mobilePayment,
  mobileDevicePayment,
  latefeecredit,
  billData,
  autopay,
  applePay,
  scheduledPayments,
  harness,
  userMessages,
  moveBillDueDate,
  paymentPlan,
  ltip,
  installmentPlans,
  session,
  user,
  nowWalletInstruments,
  nowPayment,
  stepUp,
  statement,
  otLines,
  otPaymentTransactions,
  otHOPInitialization,
  accountName,
  currentXMAutopayInstrument,
  xmEstimated,
});

export default rootReducer;
